import {handleActions} from 'redux-actions'
import * as type from './type'

export const initialState = {
    lowNpsReasonList: [],
    fetching: false,
    error: null,
    feedbackId: '',
    feedbackCreated: '',
    feedbackScore: null,
}

export default handleActions({
    [type.TOGGLE_LOW_NPS_REASON]: (state, action) => {
        const { name, value } = action.payload

        const prevLowNpsReason = [...state.lowNpsReasonList]
        return {
            ...state,
            lowNpsReasonList: (value) ? [...prevLowNpsReason, name] : prevLowNpsReason.filter(reason => reason !== name)
        }
    },
    [type.GET_FEEDBACK_DETAILS_SUCCESS]: (state, action) => {
        const { feedbackCreated, lowScoreReason, feedbackScore } = action.payload

        let lowNpsReason = [];
        if (lowScoreReason) {
            lowNpsReason = JSON.parse(lowScoreReason);
        }

        return {
            ...state,
            lowNpsReasonList: lowNpsReason,
            feedbackCreated,
            feedbackScore,
        }
    },
}, initialState)



// WEBPACK FOOTER //
// ./src/modules/feedback/state/reducer.js